/*
  Shopify modál predvolieb cookies (shopify-pc__prefs__*) nemá odkazový element
  a nedá sa nastaviť v admine – konfigurovateľný policyLink patrí len úvodnej lište.
  Preto odkaz na zásady cookies doplníme do úvodného odseku modálu sami.
*/
(function () {
  var config = window.duosCookiePolicyLink;
  if (!config || !config.url || !config.label) return;

  var LINK_ID = 'duos-cookie-policy-link';
  var INTRO_SELECTOR = '.shopify-pc__prefs__intro-main';

  function inject() {
    if (!document.getElementById('shopify-pc__prefs')) return;
    if (document.getElementById(LINK_ID)) return;

    var intro = document.querySelector(INTRO_SELECTOR);
    if (!intro) return;

    var link = document.createElement('a');
    link.id = LINK_ID;
    link.href = config.url;
    link.textContent = config.label;
    link.style.textDecoration = 'underline';
    link.style.color = 'inherit';

    intro.appendChild(document.createTextNode(' '));
    intro.appendChild(link);
  }

  var scheduled = false;
  function schedule() {
    if (scheduled) return;
    scheduled = true;
    requestAnimationFrame(function () {
      scheduled = false;
      inject();
    });
  }

  inject();
  new MutationObserver(schedule).observe(document.body, { childList: true, subtree: true });
})();
